import React from 'react';
export default function ErrorMessage(props) {
  if (props.value) {
    return /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'red'
      }
    }, props.value);
  } else {
    return null;
  }
}